import { postRequest } from '../clients/axios';

export const postGetTokenDataFromSsoToken = async (tokenSso: string) => {
  const token = await postRequest<string>('token/gettokenforpwasso', tokenSso);
  return token?.data || '';
};
